// USER
export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const CHECK_AUTH = 'CHECK_AUTH'
export const IMPERSONATE = 'IMPERSONATE'
export const REVERT_IMPERSONATE = 'REVERT_IMPERSONATE'
export const RECEIVE_USER = 'RECEIVE_USER'
export const SEND_USER = 'SEND_USER'
export const RECEIVE_EMPLOYEES = 'RECEIVE_EMPLOYEES'
export const RECEIVE_USERS = 'RECEIVE_USERS'
export const RECEIVE_DELIVERY_ADDRESS = 'RECEIVE_DELIVERY_ADDRESS'
export const RECEIVE_INVOICE_ADDRESS = 'RECEIVE_INVOICE_ADDRESS'
export const RECEIVE_SHOP_ADDRESS = 'RECEIVE_SHOP_ADDRESS'
export const RECEIVE_DEALERLOCATOR_ADDRESS = 'RECEIVE_DEALERLOCATOR_ADDRESS'
export const CUSTOMER_HIDDEN = 'CUSTOMER_HIDDEN'


// PREORDERSHEETS
export const RECEIVE_SHEETS = 'RECEIVE_SHEETS'
export const RECEIVE_SHEET = 'RECEIVE_ORDER_BY_ID'
export const RECEIVE_SHEET_PRODUCTS = 'RECEIVE_SHEET_PRODUCTS'
export const RECEIVE_SHEET_MARKETING_PRODUCTS = 'RECEIVE_SHEET_MARKETING_PRODUCTS'
export const SEND_NEW_SHEET = 'SEND_NEW_SHEET'
export const RECEIVE_TARGETS = 'RECEIVE_TARGETS'
export const RECEIVE_TARGET_SELECTED = 'RECEIVE_TARGET_SELECTED'
export const RECEIVE_BRANDS = 'RECEIVE_BRANDS'
export const RECEIVE_COLLECTIONS = 'RECEIVE_COLLECTIONS'
export const DELETE_PRODUCT_FROM_SHEET = 'DELETE_PRODUCT_FROM_SHEET'
export const DELETE_PRODUCT_GROUP_FROM_SHEET = 'DELETE_PRODUCT_GROUP_FROM_SHEET'
export const RECEIVE_PRODUCT_GROUP_SELECTED = 'RECEIVE_PRODUCT_GROUP_SELECTED'
export const DELETE_MARKETING_FROM_SHEET = 'DELETE_MARKETING_FROM_SHEET'
export const DELETE_MARKETING_GROUP_FROM_SHEET = 'DELETE_MARKETING_GROUP_FROM_SHEET'
export const RECEIVE_MARKETING_GROUP_SELECTED = 'RECEIVE_MARKETING_GROUP_SELECTED'

// PRODUCTS
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'
export const RECEIVE_PRODUCT_BY_ID = 'RECEIVE_PRODUCT_BY_ID'
export const RECEIVE_SEARCH_PRODUCTS = 'RECEIVE_SEARCH_PRODUCTS'
export const RECEIVE_AGGREGATIONS = 'RECEIVE_AGGREGATIONS'
export const RECEIVE_FAST_ORDER_PRODUCT = 'RECEIVE_FAST_ORDER_PRODUCT'
export const REMOVE_FAST_ORDER_PRODUCT = 'REMOVE_FAST_ORDER_PRODUCT'
export const REMOVE_FAST_ORDER_PRODUCTS = 'REMOVE_FAST_ORDER_PRODUCTS'
export const REMOVE_FAST_ORDER_PRODUCT_SIZES = 'REMOVE_FAST_ORDER_PRODUCT_SIZES'
export const SET_PRODUCT_ACCESS_REQUESTED = 'SET_PRODUCT_ACCESS_REQUESTED'
export const CLEAR_PRODUCT_ACCESS_REQUESTED = 'CLEAR_PRODUCT_ACCESS_REQUESTED'

// BASKET
export const RECEIVE_CURRENTBASKET = 'RECEIVE_CURRENTBASKET'
export const SUCCESS_BASKET = 'SUCCESS_BASKET'
export const UPDATE_BASKET_COUNT = 'UPDATE_BASKET_COUNT'

// PREORDERS
export const SEND_NEW_PREORDER = 'SEND_NEW_PREORDER'
export const SEND_CUSTOMERS = 'SEND_CUSTOMERS'
export const RECEIVE_CUSTOMER_BY_ID = 'RECEIVE_CUSTOMER_BY_ID'
export const SEND_CUSTOMER_BY_ID = 'SEND_CUSTOMER_BY_ID'
export const RESET_CUSTOMERS = 'RESET_CUSTOMERS'
export const SEND_CUSTOMER_SEARCH = 'SEND_CUSTOMER_SEARCH'
export const RECEIVE_PREORDERS = 'RECEIVE_PREORDERS'
export const RECEIVE_CLOSED_PREORDERS = 'RECEIVE_CLOSED_PREORDERS'
export const RECEIVE_PREORDERS_FORECASTED = 'RECEIVE_PREORDERS_FORECASTED'
export const RECEIVE_PREORDER_BY_ID = 'RECEIVE_PREORDER_BY_ID'
export const RECEIVE_PREORDER_TOTALS_BY_ID = 'RECEIVE_PREORDER_TOTALS_BY_ID'
export const RECEIVE_PREORDER_NOTIFICATIONS_BY_ID = 'RECEIVE_PREORDER_NOTIFICATIONS_BY_ID'
export const RECEIVE_PREORDER_PRODUCTS_BY_ID = 'RECEIVE_PREORDER_PRODUCTS_BY_ID'
export const RECEIVE_PREORDER_MARKETING_PRODUCTS_BY_ID = 'RECEIVE_PREORDER_MARKETING_PRODUCTS_BY_ID'
export const CLOSE_PREORDER_BY_ID = 'CLOSE_PREORDER_BY_ID'
export const UPDATE_PREORDER_BY_ID = 'UPDATE_PREORDER_BY_ID'
export const SEND_CUSTOMER_USERS = 'SEND_CUSTOMER_USERS'
export const SEND_CUSTOMER_ADDRESS = 'SEND_CUSTOMER_ADDRESS'
export const RECEIVE_PREORDER_SUBGROUP_TOTALS = 'RECEIVE_PREORDER_SUBGROUP_TOTALS'
export const RECEIVE_PREORDER_DELIVERY_MOMENT_TOTALS = 'RECEIVE_PREORDER_DELIVERY_MOMENT_TOTALS'
export const RECEIVE_PREORDER_TARGETS_AND_TOTALS = 'RECEIVE_PREORDER_TARGET_AND_TOTALS'
export const RESET_PREORDER = 'RESET_PREORDER'
export const SEND_TO_SALES = 'SEND_TO_SALES'

// ORDERS
export const RECEIVE_CUSTOMER_ORDERS = 'RECEIVE_CUSTOMER_ORDERS'
export const RECEIVE_HISTORY_ORDER_DETAIL = 'RECEIVE_HISTORY_ORDER_DETAIL'
export const RECEIVE_CUSTOMER_BACKORDERS = 'RECEIVE_CUSTOMER_BACKORDERS'
export const RECEIVE_CUSTOMER_INVOICES = 'RECEIVE_CUSTOMER_INVOICES'

//AX WARNINGS
export const RECEIVE_AX_WARNINGS = 'RECEIVE_AX_WARNINGS'
export const IGNORE_AX_WARNING = 'IGNORE_AX_WARNING'

//NOTIFICATIONS
export const RECEIVE_NOTIFICATION = 'RECEIVE_NOTIFICATION'
export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS'
export const RECEIVE_ALL_NOTIFICATIONS = 'RECEIVE_ALL_NOTIFICATIONS'

//BANNERS
export const RECEIVE_CURRENT_BANNER = 'RECEIVE_CURRENT_BANNER'
export const RECEIVE_BANNER = 'RECEIVE_BANNER'
export const RECEIVE_BANNERS = 'RECEIVE_BANNERS'

//DOWNLOADS
export const RECEIVE_DOWNLOADS = 'RECEIVE_DOWNLOADS'

//BRANCHES
export const RECEIVE_BRANCH_OPTIONS = 'RECEIVE_BRANCH_OPTIONS'
export const RECEIVE_BRANCH = 'RECEIVE_BRANCH'

//COUPONS
export const RECEIVE_COUPON_OPTIONS = 'RECEIVE_COUPON_OPTIONS'
export const RECEIVE_COUPON = 'RECEIVE_COUPON'

//COUNTRIES
export const RECEIVE_COUNTRY_OPTIONS = 'RECEIVE_COUNTRY_OPTIONS'
export const RECEIVE_AVAILABLE_COUNTRY_OPTIONS = 'RECEIVE_AVAILABLE_COUNTRY_OPTIONS'
export const RECEIVE_COUNTRY = 'RECEIVE_COUNTRY'

//SIZECHARTS
export const RECEIVE_SIZECHART_OPTIONS = 'RECEIVE_COUNTRY_OPTIONS'
export const RECEIVE_SIZECHART = 'RECEIVE_COUNTRY'

//PREORDERSHEET REPORTS
export const RECEIVE_SALESMEN = 'RECEIVE_SALESMEN'

//CURRENCIES
export const RECEIVE_CURRENCY_OPTIONS = 'RECEIVE_CURRENCY_OPTIONS'
export const RECEIVE_CURRENCY_SYMBOL = 'RECEIVE_CURRENCY_SYMBOL'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js